var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"categoria",attrs:{"cinza":""}},[_c('div',{staticClass:"categoria__cabecalho"},[_vm._t("cabecalho")],2),_c('Card',{attrs:{"borda":""}},[_c('ul',{staticClass:"categoria__itens"},[_vm._t("conteudo")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }